import React from 'react';
import { CtaButton } from '../CtaButton';
import { images } from '../../data/offer';
export function AuthorSection() {
  return <section className="w-full bg-navy-900 px-5 py-16 sm:py-24" data-id="element-49" data-mp="3m6pgk6gn0lqj">
      <div className="mx-auto grid max-w-6xl items-start gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-50" data-mp="3qyh1a0d43x8r">
        <div data-id="element-51" data-mp="3vyd3bu291elo">
          <img src={images.author} alt="Dr. Ryan Carter, creator of Low Back Pain Assessment Blueprint" className="mx-auto w-full max-w-md rounded-3xl object-cover ring-4 ring-brand/40" data-id="element-52" data-mp="3vws8e3c0vtna" />
        </div>

        <div data-id="element-53" data-mp="388ir9epr7u2h">
          <p className="font-display text-lg font-bold uppercase tracking-[0.12em] text-brand" data-id="element-54" data-mp="388sh92asu186">Meet the author</p>
          <h2 className="mt-2 font-display text-5xl font-black uppercase leading-none text-white sm:text-6xl" data-id="element-55" data-mp="3d7vo8sacahis">Dr. Ryan Carter</h2>
          <p className="mt-3 font-display text-2xl font-bold uppercase leading-tight text-slate-300" data-id="element-56" data-mp="nhs0yw44hjrj">
            Why I Created Low Back Pain Assessment Blueprint™
          </p>

          <div className="mt-6 space-y-4 text-lg leading-relaxed text-slate-300" data-id="element-57" data-mp="24720iu07on2w">
            <p data-id="element-58" data-mp="1z8igx093bndp">
              I believe that a structured assessment involves more than knowing individual tests or memorizing lists of conditions.
            </p>
            <p data-id="element-59" data-mp="1v99kfnmo1beg">
              It also involves knowing how to organize information, recognize when findings require closer attention, and understand when
              additional evaluation may be necessary.
            </p>
            <p data-id="element-60" data-mp="1gisjs6huupim">
              Low back pain can present with a wide range of symptoms and functional limitations. The information gathered during an assessment
              needs to be interpreted in context, and no single examination finding can answer every clinical question.
            </p>
            <p className="font-semibold text-white" data-id="element-61" data-mp="12ihrcz0wd2vc">That’s the focus of this educational collection.</p>
            <p data-id="element-62" data-mp="xjy1won3h8y8">
              I wanted to bring the initial assessment, screening considerations, physical examination, clinical reasoning, and case-based
              learning together in one organized resource.
            </p>
            <p data-id="element-63" data-mp="svx1c394yk5o">
              The six volumes cover these connected elements, while the five accompanying resources provide additional ways to organize and
              review the information.
            </p>
            <p data-id="element-64" data-mp="ixhl4vbncvay">
              My aim is to offer a practical educational reference that helps physiotherapists approach low back pain assessments with a clearer
              framework and a more deliberate reasoning process.
            </p>
            <p className="italic text-slate-400" data-id="element-65" data-mp="wwqnos6xjqwg">This collection is intended to complement professional education and experience, not replace them.</p>
          </div>

          <div className="mt-8 border-t border-white/10 pt-6" data-id="element-66" data-mp="11u0o12vuxmz2">
            <p className="font-display text-2xl font-extrabold uppercase text-white" data-id="element-67" data-mp="1pl5zl5urlt3k">Dr. Ryan Carter</p>
            <p className="text-sm text-slate-400" data-id="element-68" data-mp="1ud683mowhubr">Creator of Low Back Pain Assessment Blueprint™</p>
          </div>
        </div>
      </div>

      <CtaButton tone="dark" label="Explore the Complete Blueprint" sub="One-time payment of $27 · Instant access" data-id="element-69" data-mp="3f0grjh4hv002" />
    </section>;
}